/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderDailyPointDTO interface.
 */
export function instanceOfOrderDailyPointDTO(value) {
    return true;
}
export function OrderDailyPointDTOFromJSON(json) {
    return OrderDailyPointDTOFromJSONTyped(json, false);
}
export function OrderDailyPointDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'ordersCount': json['ordersCount'] == null ? undefined : json['ordersCount'],
        'revenueUsd': json['revenueUsd'] == null ? undefined : json['revenueUsd'],
        'netProfitUsd': json['netProfitUsd'] == null ? undefined : json['netProfitUsd'],
    };
}
export function OrderDailyPointDTOToJSON(json) {
    return OrderDailyPointDTOToJSONTyped(json, false);
}
export function OrderDailyPointDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0, 10)),
        'ordersCount': value['ordersCount'],
        'revenueUsd': value['revenueUsd'],
        'netProfitUsd': value['netProfitUsd'],
    };
}
